<template>
  <div>
    <section>
      <b-row>
        <b-col cols="2">
          <b-form-group :label="$t('objects.with')">
            <flat-pickr
              id="start-date"
              v-model="query_params.start_date"
              class="form-control bg-white"
              style="max-width: 250px;"
              :config="configdateTimePicker"
              @on-change="refresh"
            />
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group :label="$t('objects.by')">
            <flat-pickr
              v-model="query_params.end_date"
              class="form-control bg-white"
              style="max-width: 250px;"
              :config="configdateTimePicker"
              @on-change="refresh"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </section>
    <section>
      <b-card no-body>
        <b-table
          id="price-history-table"
          :items="GET_DISCOUNT_HISTORY.results"
          :fields="fields"
          :tbody-tr-class="['tableRowClass']"
          head-variant="dark"
          show-empty
          :empty-text="$t('general.no_records_to_show')"
          small
          :current-page="currentPage"
        >
          <template #head()="{ label }">
            {{ $t(label) }}
          </template>
          <template #empty>
            <div class="text-center">{{ $t('general.no_records_to_show') }}</div>
          </template>
          <template #cell(changes)="{ item }">
            <div v-if="item.changes.hasOwnProperty('new_area_start')">
              {{ item.changes.old_area_start }} - {{ item.changes.old_area_end }} м² => {{ item.changes.new_area_start }} - {{ item.changes.new_area_end }} м²
            </div>
            <div v-if="item.changes.hasOwnProperty('new_payment_in_percent')">
              {{ item.changes.old_payment_in_percent }}% => {{ item.changes.new_payment_in_percent }}%
            </div>
          </template>
        </b-table>
        <!-- pagination -->
        <!-- style="border-top: 1px solid lightgrey;" -->
        <div class="d-flex justify-content-between align-items-center flex-wrap mb-75 bg-white p-1">
          <div class="d-flex align-items-center mb-0">
            <span class="text-nowrap text-black ml-1">
              {{ $t('generals.show_from') }}
            </span>
            <b-form-select
              v-model="query_params.page_size"
              :options="['5','10','15']"
              class="mx-1 text-black"
              @change="refresh"
            />
            <!-- <span class="text-nowrap text-black"> {{$t('pagination.entries')}} </span> -->
          </div>
          <div class="mb-1">
            <b-pagination
              v-model="currentPage"
              :total-rows="GET_DISCOUNT_HISTORY.count"
              :per-page="query_params.page_size"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @change="refresh"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </b-card>
    </section>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BCard, BTable, BPagination, BFormSelect,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Russian } from 'flatpickr/dist/l10n/ru'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    BRow, BCol, BFormGroup, flatPickr, BCard, BTable, BPagination, BFormSelect,
  },
  data() {
    return {
      query_params: {
        start_date: '',
        end_date: '',
        id: this.$route.params.id,
        page: 1,
        page_size: 10,
      },
      currentPage: 1,
      configdateTimePicker: {
        altInput: true,
        altFormat: 'd.m.Y',
        dateFormat: 'Y-m-d',
        locale: Russian,
      },
      fields: [
        // {
        //   key: 'apartment',
        //   label: 'Диапазон',
        //   thClass: 'py-1',
        // },
        {
          key: 'modified_date',
          label: 'objects.changed_date',
          formatter(value) {
            return new Date(value).toLocaleString().split(',')[0]
          },
          thClass: 'py-1',
        },
        {
          key: 'payment_in_percent',
          label: 'objects.initial_payment_interest',
          thClass: 'py-1',
        },
        {
          key: 'changes',
          label: 'objects.change',
          thClass: 'py-1',
        },
        // {
        //   key: 'old_price_per_kv',
        //   label: 'Старая скидка',
        //   formatter(value) {
        //     return new Intl.NumberFormat('ru-Ru', { style: 'currency', currency: 'UZS' }).format(value)
        //   },
        //   thClass: 'py-1',
        // },
        // {
        //   key: 'new_price_per_kv',
        //   label: 'Новая скидка',
        //   formatter(value) {
        //     return new Intl.NumberFormat('ru-Ru', { style: 'currency', currency: 'UZS' }).format(value)
        //   },
        //   thClass: 'py-1',
        // },
      ],
    }
  },
  computed: {
    ...mapGetters('objects', ['GET_DISCOUNT_HISTORY', 'GET_OBJECT_MEDIA']),
  },
  mounted() {
    this.FETCH_DISCOUNT_HISTORY(this.query_params)
    this.FETCH_ONE_OBJECT(this.$route.params.id).then(() => {
      this.updateBreadCrumb()
    })
  },
  methods: {
    ...mapActions('objects', ['FETCH_DISCOUNT_HISTORY', 'FETCH_ONE_OBJECT']),
    ...mapMutations('breadcrumb', ['UPDATE_BREADCRUMB']),
    updateBreadCrumb() {
      const [first, second, third] = this.$_removeObjectConnection(this.$route.meta.breadcrumb)
      second.text = this.GET_OBJECT_MEDIA.title
      second.to = second.to.replace(':id', this.$route.params.id)
      this.UPDATE_BREADCRUMB([first, second, third])
    },
    refresh() {
      clearTimeout(this.delay)
      this.delay = setTimeout(() => {
        this.FETCH_DISCOUNT_HISTORY(this.query_params)
      }, 200)
    },
    changePerPage() {
      this.refresh()
    },
    changePage() {
      this.refresh()
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";

</style>
